import { render, staticRenderFns } from "./ProjectItems.vue?vue&type=template&id=631d21ac&scoped=true&"
import script from "./ProjectItems.vue?vue&type=script&lang=ts&"
export * from "./ProjectItems.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectItems.vue?vue&type=style&index=0&id=631d21ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631d21ac",
  null
  
)

export default component.exports